package br.com.texeratx.boardgametimeapp.ui.screens.dashboard

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import br.com.texeratx.boardgametimeapp.core.session.SessionManager
import br.com.texeratx.boardgametimeapp.ui.feedback.AppUiEvent
import br.com.texeratx.boardgametimeapp.ui.feedback.AppUiEventBus
import br.com.texeratx.boardgametimeapp.ui.screens.clan.ClanScreen
import br.com.texeratx.boardgametimeapp.ui.screens.games.GameScreen
import br.com.texeratx.boardgametimeapp.ui.screens.games.detail.GameDetailScreen
import br.com.texeratx.boardgametimeapp.ui.screens.login.LoginScreen
import br.com.texeratx.boardgametimeapp.ui.screens.matches.MatchesScreen
import br.com.texeratx.boardgametimeapp.ui.screens.matches.detail.MatchDetailScreen
import br.com.texeratx.boardgametimeapp.ui.screens.matches.model.MatchGameUI
import br.com.texeratx.boardgametimeapp.ui.screens.matches.model.MatchListItemUI
import br.com.texeratx.boardgametimeapp.ui.screens.matches.model.MatchPlayerUI
import br.com.texeratx.boardgametimeapp.ui.screens.players.PlayersScreen
import br.com.texeratx.boardgametimeapp.ui.screens.players.detail.PlayerDetailScreen
import br.com.texeratx.boardgametimeapp.ui.screens.stats.StatsScreen
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import kotlinx.coroutines.launch
import org.koin.compose.koinInject

class DashboardScreen : Screen {

    @Composable
    override fun Content() {
        val viewModel = koinInject<DashboardViewModel>()
        val state by viewModel.state.collectAsState()
        val sessionManager = koinInject<SessionManager>()
        val coroutineScope = rememberCoroutineScope()

        val navigator = LocalNavigator.currentOrThrow

        var clanName by remember { mutableStateOf("Dashboard") }
        var clanImageUrl by remember { mutableStateOf<String?>(null) }

        LaunchedEffect(Unit) {
            sessionManager.load()?.let { session ->
                clanName = session.activeClanName.orEmpty().ifBlank { "Dashboard" }
                clanImageUrl = session.activeClanImageUrl
            }
            viewModel.loadDashboard()
        }

        LaunchedEffect(Unit) {
            AppUiEventBus.events.collect { event ->
                when (event) {
                    is AppUiEvent.GameDeleted,
                    is AppUiEvent.PlayerDeleted,
                    AppUiEvent.ClanUpdated -> {
                        sessionManager.load()?.let { session ->
                            clanName = session.activeClanName.orEmpty().ifBlank { "Dashboard" }
                            clanImageUrl = session.activeClanImageUrl
                        }
                        viewModel.loadDashboard()
                    }
                    is AppUiEvent.UiMessage -> Unit
                    is AppUiEvent.SessionExpired -> Unit // tratado globalmente no AppNavigation
                }
            }
        }

        DashboardUI(
            state,
            onTopGamesClick = { navigator.push(GameScreen()) },
            onTopPlayersClick = { navigator.push(PlayersScreen()) },
            onDismissError = { viewModel.state.value = state.copy(error = null) },
            onLogout = {
                coroutineScope.launch {
                    sessionManager.clearActiveClan()
                    navigator.replaceAll(br.com.texeratx.boardgametimeapp.ui.screens.myclans.MyClansScreen())
                }
            },
            onGameClick = { gameId ->
                navigator.push(GameDetailScreen(gameId))
            },
            onPlayerClick = { playerId ->
                navigator.push(PlayerDetailScreen(playerId))
            },
            onStatsClick = { navigator.push(StatsScreen()) },
            clanName = clanName,
            clanImageUrl = clanImageUrl,
            onClanClick = { navigator.push(ClanScreen()) },
            onLastMatchesClick = { navigator.push(MatchesScreen()) },
            onLastMatchClick = { last ->

                val stubMatch = MatchListItemUI(
                    id = last.matchId,
                    date = last.date,
                    duration = last.duration,
                    game = MatchGameUI(
                        id = 0L, // não vem do dashboard
                        name = last.gameName,
                        imageUrl = last.gameImageUrl
                    ),
                    players = last.players.map { playerName ->
                        MatchPlayerUI(
                            id = 0L,              // não vem do dashboard
                            name = playerName,
                            nickname = null,      // não vem do dashboard
                            imageUrl = null,      // não vem do dashboard
                            points = 0.0          // não vem do dashboard
                        )
                    },
                    expansionIds = emptyList() // não vem do dashboard
                )

                navigator.push(MatchDetailScreen(stubMatch))
            }
        )
    }
}
